import React, { useState, useEffect } from "react";
import { HotSpotsDataContext } from "./context";

import { getHotSpotsData } from "../services/services";

const HotSpotsProvider = ({ children }) => {
  const [hotSpotsData, setHotSpotsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHotSpots = async () => {
      const hotSpots = await getHotSpotsData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setHotSpotsData(hotSpots);
    };

    fetchHotSpots();
  }, []);

  return (
    <HotSpotsDataContext.Provider
      value={{ hotSpotsData, setHotSpotsData, loading, error }}
    >
      {children}
    </HotSpotsDataContext.Provider>
  );
};

export default HotSpotsProvider;
